/* ==========================================================================
   search-dropdown.js — The Park Wholesale
   Header search dropdown.
   - Empty box (always two columns on desktop):
       left  = Recent searches, or Popular right now when there are none
       right = Recently viewed, or the New arrival card when there are none
       returning visitors: "Clear history" under both; slim Empire Cove strip
       only when recently viewed fills the right column (else the card is there)
   - No results: Trending + "No results menu" + help row, no promo
   - 1+ characters: predictive results via Section Rendering
     (sections/predictive-search.liquid)
   Markup: snippets/search-dropdown.liquid · Styles: assets/search-dropdown.css

   Phones: the dropdown is sized to the space above the on-screen keyboard; scrolling the list
   closes the keyboard but keeps the dropdown open (a tap outside still closes it).

   Keyboard (focus stays in the input, combobox + listbox pattern):
   ↓ / ↑ move through options (wraps) · Home / End first / last option
   Enter opens the highlighted option ("Clear" clears history), otherwise submits
   Esc closes the dropdown, a second Esc clears the text · Tab moves on normally
   ========================================================================== */
(function () {
  'use strict';

  if (window.__searchDropdownInit) return;
  window.__searchDropdownInit = true;

  var MIN_CHARS = 1;
  var DEBOUNCE_MS = 200;
  var SHOW_RECENT = 3;
  var SHOW_VIEWED = 3;
  var STORE_MAX = 8;
  var CACHE_MAX = 50;
  var KEY_SEARCHES = 'tpw:recentSearches';
  var KEY_VIEWED = 'tpw:recentViewed';

  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var resultCache = new Map();
  var optionSeq = 0;

  /* ---------- storage (fails silently in private mode) ---------- */
  function read(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* ignore */ }
  }
  function remove(key) {
    try { localStorage.removeItem(key); } catch (e) { /* ignore */ }
  }
  function addSearch(term) {
    term = String(term || '').trim();
    if (!term) return;
    var lower = term.toLowerCase();
    var list = read(KEY_SEARCHES).filter(function (t) { return String(t).toLowerCase() !== lower; });
    list.unshift(term);
    write(KEY_SEARCHES, list.slice(0, STORE_MAX));
  }

  /* ---------- remember the product being viewed (header outputs its JSON on product pages) ---------- */
  var currentHandle = null;
  var currentEl = document.querySelector('[data-sdd-current-product]');
  if (currentEl) {
    try {
      var cp = JSON.parse(currentEl.textContent);
      if (cp && cp.handle) {
        currentHandle = cp.handle;
        var viewed = read(KEY_VIEWED).filter(function (p) { return p && p.handle !== cp.handle; });
        viewed.unshift({ handle: cp.handle, title: cp.title, url: cp.url, image: cp.image || '' });
        write(KEY_VIEWED, viewed.slice(0, STORE_MAX));
      }
    } catch (e) { /* ignore */ }
  }

  // type=product: the search page lists products only, so pages and articles
  // shouldn't take places (and count) in the results.
  function searchUrl(term) {
    return root + 'search?q=' + encodeURIComponent(term) + '&type=product';
  }
  // Suggested-search links from Shopify's predictive search (/search?q=…) get it too.
  function productsOnly(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('/search?') === -1 || /[?&]type=/.test(href)) return;
      a.setAttribute('href', href + '&type=product');
    });
  }
  function suggestUrl(term) {
    return root + 'search/suggest?q=' + encodeURIComponent(term) +
      '&section_id=predictive-search' +
      '&resources[type]=query,product,collection,page' +
      '&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';
  }

  document.querySelectorAll('form[data-search-dropdown]').forEach(init);

  function init(form) {
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('[data-sdd]');
    if (!input || !box) return;

    function q(sel) { return box.querySelector(sel); }

    var listbox = q('[data-sdd-listbox]');
    var emptyEl = q('[data-sdd-empty]');
    var cols = q('[data-sdd-cols]');
    var colLeft = q('[data-sdd-col-left]');
    var colRight = q('[data-sdd-col-right]');
    var resultsEl = q('[data-sdd-results]');
    var message = q('[data-sdd-message]');
    var recentGrp = q('[data-sdd-recent]');
    var recentList = q('[data-sdd-recent-list]');
    var viewedGrp = q('[data-sdd-viewed]');
    var viewedList = q('[data-sdd-viewed-list]');
    var popular = q('[data-sdd-popular]');
    var spotCard = q('[data-sdd-spot-card]');
    var spotStrip = q('[data-sdd-spot-strip]');
    var quote = q('[data-sdd-quote]');
    var nrBlock = q('[data-sdd-nr]');
    var foot = q('[data-sdd-foot]');
    var tplRecent = q('[data-sdd-tpl-recent]');
    var tplViewed = q('[data-sdd-tpl-viewed]');
    var status = form.querySelector('[data-sdd-status]');
    var supportInfo = document.querySelector('.support_info');

    var items = [];
    var active = -1;
    var timer = null;
    var controller = null;
    var lastAnnounced = null;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', listbox.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');

    function setHidden(el, hidden) { if (el) el.hidden = hidden; }
    function isShown(el) { return !!el && !el.hidden; }

    /* ---------- open / close ---------- */
    function isOpen() { return !box.hidden; }

    /* desktop: line the dropdown up with the visible search field (input + button) */
    var submitBtn = form.querySelector('[type="submit"], .srch-btn');
    var desktop = window.matchMedia('(min-width: 990px)');
    function align() {
      if (!desktop.matches) {
        box.style.removeProperty('left');
        box.style.removeProperty('width');
        return;
      }
      var f = form.getBoundingClientRect();
      var a = input.getBoundingClientRect();
      var b = submitBtn ? submitBtn.getBoundingClientRect() : a;
      var left = Math.min(a.left, b.left);
      var right = Math.max(a.right, b.right);
      box.style.left = (left - f.left) + 'px';
      box.style.width = (right - left) + 'px';
    }
    var alignFrame = 0;
    window.addEventListener('resize', function () {
      if (!isOpen()) return;
      cancelAnimationFrame(alignFrame);
      alignFrame = requestAnimationFrame(align);
    });

    function open() {
      if (isOpen()) return;
      align();
      box.hidden = false;
      fit();
      box.classList.add('active');
      input.setAttribute('aria-expanded', 'true');
      form.classList.add('active');
      if (supportInfo) supportInfo.classList.add('hidden');
    }

    function close() {
      if (!isOpen()) return;
      box.hidden = true;
      box.classList.remove('active');
      input.setAttribute('aria-expanded', 'false');
      setActive(-1);
      form.classList.remove('active');
      if (supportInfo) supportInfo.classList.remove('hidden');
    }

    function announce(text) {
      if (!status) return;
      status.textContent = '';
      window.setTimeout(function () { status.textContent = text; }, 60);
    }

    /* ---------- options & highlight ---------- */
    function collect() {
      items = Array.prototype.filter.call(listbox.querySelectorAll('[role="option"]'), function (el) {
        return el.getClientRects().length > 0;
      });
      items.forEach(function (el) {
        if (!el.id) el.id = box.id + '-opt-' + (++optionSeq);
        el.setAttribute('aria-selected', 'false');
      });
      active = -1;
      input.removeAttribute('aria-activedescendant');
    }

    function setActive(index, fromPointer) {
      if (active >= 0 && items[active]) items[active].setAttribute('aria-selected', 'false');
      active = index;
      if (index < 0 || !items[index]) {
        active = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      var el = items[index];
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      if (!fromPointer) el.scrollIntoView({ block: 'nearest' });
    }

    /* ---------- empty state ---------- */
    function renderEmpty() {
      var searches = read(KEY_SEARCHES);
      var viewed = read(KEY_VIEWED).filter(function (p) { return p && p.handle && p.handle !== currentHandle; });
      var returning = searches.length > 0 || viewed.length > 0;

      // recent searches
      recentList.replaceChildren();
      searches.slice(0, SHOW_RECENT).forEach(function (term) {
        var li = tplRecent.content.firstElementChild.cloneNode(true);
        var a = li.querySelector('a');
        a.href = searchUrl(term);
        a.setAttribute('data-sdd-query', term);
        li.querySelector('[data-sdd-text]').textContent = String(term);
        recentList.appendChild(li);
      });

      // recently viewed
      viewedList.replaceChildren();
      viewed.slice(0, SHOW_VIEWED).forEach(function (p) {
        var li = tplViewed.content.firstElementChild.cloneNode(true);
        li.querySelector('a').href = p.url || (root + 'products/' + p.handle);
        var img = li.querySelector('[data-sdd-img]');
        if (p.image) {
          img.src = p.image;
        } else {
          var ph = document.createElement('span');
          ph.className = 'sdd__product-img';
          ph.setAttribute('aria-hidden', 'true');
          img.replaceWith(ph);
        }
        li.querySelector('[data-sdd-text]').textContent = p.title || '';
        viewedList.appendChild(li);
      });

      var hasRecent = recentList.children.length > 0;
      var hasViewed = viewedList.children.length > 0;

      // left column: recent searches, else popular right now
      setHidden(recentGrp, !hasRecent);
      setHidden(popular, hasRecent);
      // right column: recently viewed, else the new arrival card
      setHidden(viewedGrp, !hasViewed);
      setHidden(spotCard, hasViewed);
      // slim strip for returning visitors, unless the card is already in the right column
      setHidden(spotStrip, !(returning && hasViewed));
      // one "Clear history" under both columns
      setHidden(foot, !returning);

      var leftHas = isShown(recentGrp) || isShown(popular);
      var rightHas = isShown(viewedGrp) || isShown(spotCard);
      setHidden(colLeft, !leftHas);
      setHidden(colRight, !rightHas);
      setHidden(cols, !leftHas && !rightHas);
      cols.classList.toggle('sdd__cols--single', !(leftHas && rightHas));
      box.classList.toggle('sdd--returning', returning);

      setHidden(emptyEl, false);
      setHidden(message, true);
      message.replaceChildren();
      setHidden(quote, true);
      setHidden(nrBlock, true);
      setHidden(resultsEl, true);
      resultsEl.replaceChildren();
      listbox.removeAttribute('aria-busy');

      return leftHas || rightHas || isShown(spotStrip);
    }

    /* ---------- results (1+ characters) ---------- */
    function showLoading() {
      setHidden(emptyEl, true);
      setHidden(spotStrip, true);
      setHidden(message, true);
      setHidden(quote, true);
      setHidden(nrBlock, true);
      setHidden(resultsEl, false);
      resultsEl.innerHTML =
        '<div class="sdd__skeleton" aria-hidden="true">' +
          '<span class="sdd__sk sdd__sk--short"></span><span class="sdd__sk"></span>' +
          '<span class="sdd__sk sdd__sk--row"></span><span class="sdd__sk sdd__sk--row"></span>' +
        '</div>';
      listbox.setAttribute('aria-busy', 'true');
      collect();
    }

    function showResults(html, query) {
      listbox.removeAttribute('aria-busy');
      setHidden(emptyEl, true);
      resultsEl.innerHTML = html;
      productsOnly(resultsEl);
      setHidden(resultsEl, false);

      var noResults = resultsEl.querySelector('[data-psr-message]');
      if (noResults) {
        message.replaceChildren(noResults);
        setHidden(message, false);
        setHidden(spotStrip, true);   // no promo when nothing was found
        setHidden(nrBlock, false);
        setHidden(quote, false);
      } else {
        setHidden(message, true);
        message.replaceChildren();
        setHidden(spotStrip, true);
        setHidden(nrBlock, true);
        setHidden(quote, true);
      }

      collect();

      if (lastAnnounced !== query) {
        var count = resultsEl.querySelectorAll('[role="option"]:not(.predictive-search__item--term)').length;
        announce(noResults
          ? 'No results for ' + query + '.'
          : count + (count === 1 ? ' result' : ' results') + ' available. Use the up and down arrows to browse.');
        lastAnnounced = query;
      }
    }

    function fetchResults(query) {
      var key = query.toLowerCase();
      if (resultCache.has(key)) {
        showResults(resultCache.get(key), query);
        return;
      }
      if (controller) controller.abort();
      var own = new AbortController();
      controller = own;
      showLoading();

      fetch(suggestUrl(query), { signal: own.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (text) {
          if (own.signal.aborted) return;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var psr = doc.querySelector('[data-psr]');
          var html = psr ? psr.innerHTML : '';
          resultCache.set(key, html);
          if (resultCache.size > CACHE_MAX) resultCache.delete(resultCache.keys().next().value);
          if (input.value.trim().toLowerCase() === key) showResults(html, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          listbox.removeAttribute('aria-busy');
          resultsEl.replaceChildren();
          collect();
          announce('Search suggestions could not load. Press Enter to search.');
        })
        .finally(function () {
          if (controller === own) controller = null;
        });
    }

    /* ---------- actions ---------- */
    function clearHistory() {
      remove(KEY_SEARCHES);
      remove(KEY_VIEWED);
      if (renderEmpty()) collect(); else close();
      announce('Search history cleared.');
      input.focus();
    }

    // Save the search when any result is opened: the suggestion text for
    // suggestions / "See all", otherwise what the visitor typed.
    function remember(option) {
      var term = option.getAttribute('data-sdd-query');
      if (!term && resultsEl.contains(option)) term = input.value.trim();
      if (term) addSearch(term);
    }

    function choose(option) {
      if (option.hasAttribute('data-sdd-clear')) { clearHistory(); return; }
      remember(option);
      if (option.href) window.location.href = option.href;
    }

    /* ---------- input / keyboard / pointer ---------- */
    function update() {
      window.clearTimeout(timer);
      var query = input.value.trim();

      if (query.length < MIN_CHARS) {
        if (controller) { controller.abort(); controller = null; }
        lastAnnounced = null;
        if (renderEmpty()) { open(); collect(); } else { close(); }
        return;
      }

      timer = window.setTimeout(function () {
        open();
        fetchResults(query);
      }, DEBOUNCE_MS);
    }

    input.addEventListener('focus', update);
    input.addEventListener('input', update);

    input.addEventListener('keydown', function (event) {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          if (!isOpen()) { update(); return; }
          if (items.length) setActive(active < items.length - 1 ? active + 1 : 0);
          break;
        case 'ArrowUp':
          event.preventDefault();
          if (!isOpen()) { update(); return; }
          if (items.length) setActive(active > 0 ? active - 1 : items.length - 1);
          break;
        case 'Home':
          if (isOpen() && active >= 0 && items.length) { event.preventDefault(); setActive(0); }
          break;
        case 'End':
          if (isOpen() && active >= 0 && items.length) { event.preventDefault(); setActive(items.length - 1); }
          break;
        case 'Enter':
          if (isOpen() && active >= 0 && items[active]) {
            event.preventDefault();
            choose(items[active]);
          }
          break;
        case 'Escape':
          if (isOpen()) {
            event.preventDefault();
            close();
          } else if (input.value) {
            event.preventDefault();
            input.value = '';
          }
          break;
        default:
          break;
      }
    });

    // keep focus in the input when clicking inside the dropdown (the click itself still works)
    box.addEventListener('mousedown', function (event) { event.preventDefault(); });

    box.addEventListener('mousemove', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option) return;
      var index = items.indexOf(option);
      if (index !== -1 && index !== active) setActive(index, true);
    });

    listbox.addEventListener('click', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option) return;
      if (option.hasAttribute('data-sdd-clear')) {
        event.preventDefault();
        clearHistory();
        return;
      }
      remember(option);
      // links navigate normally (Ctrl/Cmd-click opens a new tab)
    });

    form.addEventListener('submit', function () {
      addSearch(input.value);
    });

    /* ---------- phones: keep the list above the on-screen keyboard ---------- */
    var phone = window.matchMedia('(max-width: 749px)');
    var keyboardHidden = false; // true when we closed the keyboard only to show the whole list
    function fit() {
      if (!phone || !phone.matches || !window.visualViewport || box.hidden) {
        box.style.removeProperty('max-height');
        return;
      }
      var vv = window.visualViewport;
      var room = vv.height + vv.offsetTop - box.getBoundingClientRect().top - 8;
      box.style.maxHeight = Math.max(180, Math.round(room)) + 'px';
    }
    input.addEventListener('focus', function () {
      keyboardHidden = false;
      if (phone.matches) window.setTimeout(fit, 300); // after the keyboard has opened
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fit);
      window.visualViewport.addEventListener('scroll', fit);
    }
    box.addEventListener('touchmove', function () {
      if (phone.matches && document.activeElement === input) {
        keyboardHidden = true;
        input.blur();
      }
    }, { passive: true });

    // close when focus leaves the whole search form
    form.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (keyboardHidden) return; // keyboard hidden on purpose to show the list: stay open
        if (!form.contains(document.activeElement)) close();
      }, 120);
    });

    document.addEventListener('pointerdown', function (event) {
      if (isOpen() && !form.contains(event.target)) close();
    });
  }
})();